import { Form, Formik, FormikErrors, FormikProps } from 'formik';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import buildingsApi, { CreateBuildingDataType } from '../../../APIs/buildings';
import ConfirmationModalBuilding from '../../../components/ConfirmationModal/ConfirmationModal';
import escConstants from '../../../constants';
import {
  Alert,
  BrowseFile,
  Button,
  ErrorMessage,
  FormContainer,
  Input,
  NavigateBack,
  Radio,
  TextArea,
  Typography,
} from '../../../designComponents';
import ListImages from '../../../designComponents/BrowseFile/ListImage';
import { BUILDING_ROUTE } from '../../../routes/routePaths';
import { RootState } from '../../../store/selectors';
import {
  FileWithKeys,
  getFileURL,
  requestAPI,
  uploadFilesToS3,
} from '../../../utils';
import { ViewJobContainerStyled } from '../../BrowseJobs/BrowseJobDetails/style';
import { BuildingContainer, RadioContainer, SecondContainer } from './style';
import validation, { updateBuildingValidation } from './validation';
// const cardData = [
//   { price: 15, quantity: '1 to 10', package: 'Standard' },
//   { price: 25, quantity: '1 to 50', package: 'Professional' },
//   { price: 55, quantity: '100+', package: 'Enterprise' },
// ];

const optionsForCreatingBuildings = [
  {
    label: 'Provide your own blueprints:',
    desc: 'If you have a blueprint of your building, please upload it to proceed with the building creation process.',
  },
  {
    label: 'Hire Our Professionals:',
    desc: "If you don't have a blueprint, you can hire our professionals to create one for you. Simply select the option to hire a professional when prompted.",
  },
];

const AddBuilding = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [files, setFiles] = useState<File[]>([]);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [hasBlueprint, _setHasBlueprint] = useState<boolean>(true);
  const [hasHiredProfessional, sethasHiredProfessional] = useState(true);
  // const [hasNoBlueprint, setHasNoBlueprint] = useState<boolean>(true);
  // const [selectedCard, setSelectedCard] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);
  const formikRef = useRef<FormikProps<CreateBuildingDataType>>(null);

  const [errorMessage, setErrorMessage] = useState('');
  let initialValues: CreateBuildingDataType = {
    buildingName: '',
    buildingAddress: '',
    createdBy: '',
    notes: '',
    bluePrints: [],
  };

  // const theme = useTheme();
  // const handleCardClick = (index: number) => {
  //   setSelectedCard(index === selectedCard ? null : index);
  // };

  const buildingsDetails = useSelector(
    (state: RootState) => state.buildingsDetails,
  );

  const editString = searchParams.get('edit');
  const editBuildingId = editString ? editString.split('-')[1] : '';

  if (buildingsDetails && buildingsDetails?._id === editBuildingId) {
    initialValues = {
      buildingName: buildingsDetails.buildingName,
      buildingAddress: buildingsDetails.buildingAddress,
      createdBy: '',
      notes: buildingsDetails.notes,
      bluePrints: buildingsDetails?.bluePrints || [],
    };
  }

  useEffect(() => {
    if (editString?.includes('building-')) {
      const getBuildingDetails = async (id: string) => {
        try {
          setLoading(true);
          await requestAPI(buildingsApi.getBuildingsDetails(id));
        } catch (error) {
          console.error(error);
        }
        setLoading(false);
      };
      if (!buildingsDetails?._id) {
        getBuildingDetails(editBuildingId);
      }
    }
  }, [searchParams]);

  // const handleRadiosecondChange = (value: string) => {
  //   setHasNoBlueprint(value === 'Yes');
  // };

  // const handleHaveBluePrintChange = (value: string) => {
  //   console.log(value);

  //   setHasBlueprint(value === 'Yes');
  // };
  const handleHireProfessional = (value: string) => {
    sethasHiredProfessional(value === 'Yes');
  };

  const handleBuildingCreate = async (values: typeof initialValues) => {
    try {
      setErrorMessage('');
      if (files.length === 0) return;

      setLoading(true);
      let fileWithKeys: FileWithKeys[] = [];
      if (files && files.length > 0) {
        fileWithKeys = (await uploadFilesToS3(files)) as FileWithKeys[];
      }

      if (fileWithKeys && fileWithKeys.length === files.length) {
        await requestAPI(
          buildingsApi.createBuilding({
            buildingName: values.buildingName,
            buildingAddress: values.buildingAddress,
            notes: values.notes,

            bluePrints: values.bluePrints
              ? values.bluePrints.map((val) => ({
                bluePrintUrl: val?.blueprintFile
                  ? getFileURL(fileWithKeys, val?.blueprintFile)
                  : '',
                title: val.title,
              }))
              : [],
          }),
        );
      }
      setLoading(false);
      toast(escConstants.toastMessages.buildingCreated);
      navigate(BUILDING_ROUTE);
    } catch (error: any) {
      if (typeof error === 'string') {
        setErrorMessage(error);
      }
      if (error.error && typeof error.error === 'string') {
        setErrorMessage(error.error);
      }
      setLoading(false);
      console.error(error);
    }
  };
  const handleUpdateBuilding = async (values: typeof initialValues) => {
    try {
      setErrorMessage('');

      setLoading(true);
      const bluePrintUrls = values.bluePrints
        .map((item) => item.bluePrintUrl)
        .filter(Boolean);

      const bluePrintFiles = values.bluePrints
        .map((item) => item.blueprintFile)
        .filter(Boolean) as File[];

      let keys: FileWithKeys[] = (await uploadFilesToS3(
        bluePrintFiles,
      )) as FileWithKeys[];
      if (keys) {
        const newArray = [...bluePrintUrls, ...keys];
        console.log('newArr', newArray);

        if (newArray.length > 0) {
          await requestAPI(
            buildingsApi.updateBuilding(editBuildingId, {
              buildingName: values.buildingName,
              buildingAddress: values.buildingAddress,
              notes: values.notes,
              bluePrints: values.bluePrints
                ? values.bluePrints.map((val) => ({
                  bluePrintUrl: val?.blueprintFile
                    ? getFileURL(keys, val?.blueprintFile)
                    : val?.bluePrintUrl,
                  title: val.title,
                }))
                : [],
            }),
          );
        }
        setLoading(false);
        toast('Building updated successfully');
        navigate(-1);
      } else {
        const newArray = [...bluePrintUrls];
        if (newArray.length > 0) {
          await requestAPI(
            buildingsApi.updateBuilding(editBuildingId, {
              buildingName: values.buildingName,
              buildingAddress: values.buildingAddress,
              notes: values.notes,
              bluePrints: values.bluePrints
                ? values.bluePrints.map((val, index) => ({
                  bluePrintUrl: newArray[index],
                  title: val.title,
                }))
                : [],
            }),
          );
        }
        setLoading(false);
        toast('Building updated successfully');
        navigate(-1);
      }
    } catch (error: any) {
      if (typeof error === 'string') {
        setErrorMessage(error);
      }
      if (error.error && typeof error.error === 'string') {
        setErrorMessage(error.error);
      }
      setLoading(false);
      console.error(error);
    }
  };
  // const euroSymbol = '\u20AC';

  return (
    <ViewJobContainerStyled>
      <div
        style={{
          position: 'sticky',
          top: '60px',
          zIndex: '999',
          paddingTop: '5px',
          background: '#fff',
        }}
      >
        <NavigateBack />
      </div>
      <BuildingContainer className="contents">
        <Typography size={16} color="#333" style={{ marginBottom: '20px' }}>
          Create Building
        </Typography>
        {errorMessage ? (
          <div style={{ marginBottom: '10px' }}>
            <Alert text={errorMessage} type="error" />
          </div>
        ) : null}
        <Formik
          initialValues={initialValues}
          onSubmit={
            editBuildingId ? handleUpdateBuilding : handleBuildingCreate
          }
          enableReinitialize
          validationSchema={
            editBuildingId
              ? updateBuildingValidation(
                typeof formikRef.current?.values?.bluePrints !==
                    'undefined' &&
                    formikRef.current?.values?.bluePrints.length > 0,
              )
              : validation.Building
          }
          innerRef={formikRef}
        >
          {({ values, setFieldValue, errors, handleSubmit, touched }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <FormContainer
                  label="Name of Building"
                  error={touched?.buildingName ? errors.buildingName : ''}
                  marginBottom="20px"
                >
                  <Input
                    name="buildingName"
                    value={values.buildingName}
                    onChange={(e) =>
                      setFieldValue('buildingName', e.target.value)
                    }
                    placeholder="Building Name"
                  />
                </FormContainer>

                <FormContainer
                  label="Address of Property"
                  error={touched?.buildingAddress ? errors.buildingAddress : ''}
                  marginBottom="20px"
                >
                  <Input
                    name="buildingAddress"
                    value={values.buildingAddress || ''}
                    onChange={(e) =>
                      setFieldValue('buildingAddress', e.target.value)
                    }
                    placeholder="Building Address"
                  />
                </FormContainer>

                {/* <div>
                  <Typography style={{ marginBottom: '20px' }}>
                    Do you have a blueprint of property ?
                  </Typography>
                  <RadioContainer>
                    <Radio
                      name="hasBuilding"
                      value="Yes"
                      onChange={() => handleHaveBluePrintChange('Yes')}
                      label="Yes"
                      checked={hasBlueprint}
                    />
                    <Radio
                      name="hasBuilding"
                      value="No"
                      onChange={() => handleHaveBluePrintChange('No')}
                      label="No"
                      checked={!hasBlueprint}
                    />
                  </RadioContainer>
                </div> */}

                {hasBlueprint ? (
                  <Typography style={{ marginBottom: '20px' }}>
                    Upload the blueprint of your building
                  </Typography>
                ) : (
                  ''
                )}

                {hasBlueprint ? (
                  <>
                    <Typography style={{ marginBottom: '10px' }}>
                      You can upload blueprints in either SVG, PNG, or JPG
                      format,
                      <br />
                      and you also have the option to add multiple blueprints.
                    </Typography>

                    {Array.isArray(values.bluePrints)
                      ? values.bluePrints.map((blueprint, index) => {
                        const file = blueprint.blueprintFile;

                        const checkExtension = () => {
                          if (!file) {
                            return (
                                <ListImages
                                  imagesURL={[
                                    {
                                      id: `${index}`,
                                      URL: blueprint?.bluePrintUrl || '',
                                    },
                                  ]}
                                  enableRemoveImage
                                  onRemove={(id: string) => {
                                    setFieldValue(
                                      'bluePrints',
                                      values?.bluePrints?.filter((_, idx) => {
                                        return String(idx) !== id;
                                      }),
                                    );
                                  }}
                                />
                            );
                          }
                          if (!file) {
                            return;
                          }

                          return (
                              <div>
                                <ListImages
                                  files={[file]}
                                  setFiles={setFiles}
                                  noWrapper
                                  onRemoveFile={() => {
                                    values.bluePrints.splice(index, 1);
                                    if (setFiles) {
                                      setFiles([...files]);
                                    }
                                  }}
                                />
                              </div>
                          );
                        };

                        return (
                            <div
                              key={index}
                              style={{
                                margin: '10px',
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: '20px',
                                width: '100%',
                              }}
                            >
                              <div
                                style={{ width: '200px' }}
                                className="image-wrapper"
                              >
                                {checkExtension()}
                              </div>

                              <div
                                style={{
                                  width: '100%',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: '10px',
                                }}
                              >
                                <FormContainer
                                  label="Floor Title"
                                  error={
                                    touched.bluePrints &&
                                    touched.bluePrints[index] &&
                                    touched.bluePrints[index].title
                                      ? errors.bluePrints &&
                                        (
                                          errors.bluePrints[
                                            index
                                          ] as FormikErrors<{
                                            title: string;
                                          }>
                                        )?.title
                                      : ''
                                  }
                                >
                                  <Input
                                    placeholder="Please enter floor title"
                                    value={
                                      values.bluePrints[index]
                                        ? values.bluePrints[index]?.title || ''
                                        : ''
                                    }
                                    onChange={(e) => {
                                      const newBlueprints = [
                                        ...values.bluePrints,
                                      ];
                                      if (!newBlueprints[index]) {
                                        newBlueprints[index] = { title: '' };
                                      }
                                      newBlueprints[index] = {
                                        ...newBlueprints[index],
                                        title: e.target.value,
                                      };
                                      setFieldValue(
                                        'bluePrints',
                                        newBlueprints,
                                      );
                                    }}
                                  />
                                </FormContainer>
                              </div>
                            </div>
                        );
                      })
                      : []}

                    <BrowseFile
                      setFiles={(browsedFiles: File[]) => {
                        setFiles(browsedFiles);

                        const newBlueprints = [...values.bluePrints];

                        newBlueprints.push({
                          title: '',
                          blueprintFile: browsedFiles[browsedFiles.length - 1],
                        });
                        setFieldValue('bluePrints', newBlueprints);
                      }}
                      files={files}
                      accepts=".pdf, .png, .svg, .jpeg"
                      showSelectFiles={false}
                    />
                    {touched.bluePrints &&
                      errors.bluePrints &&
                      typeof errors.bluePrints === 'string' && (
                        <ErrorMessage text={errors.bluePrints} />
                    )}

                    <FormContainer
                      label="Notes"
                      error={touched?.notes ? errors.notes : ''}
                      style={{ marginBottom: '10px', marginTop: '20px' }}
                    >
                      <TextArea
                        name="notes"
                        value={values.notes || ''}
                        onChange={(e) => setFieldValue('notes', e.target.value)}
                        placeholder="Please add notes"
                        showCount={true}
                        maxLength={800}
                      />
                    </FormContainer>

                    <Button
                      variant="secondary"
                      style={{ padding: '15px 20px' }}
                      isLoading={loading}
                      onClick={async () => {
                        if (formikRef.current) {
                          await formikRef.current.validateForm();

                          if (editBuildingId) {
                            setIsOpen(true);
                          } else {
                            formikRef.current.setTouched({
                              bluePrints:
                                formikRef.current.values.bluePrints.map(() => ({
                                  title: true,
                                })),
                              buildingAddress: true,
                              buildingName: true,
                              createdBy: true,
                              notes: true,
                            });
                            if (
                              Object.keys(formikRef.current.errors).length > 0
                            ) {
                              return;
                            }
                            setIsOpen(true);
                          }
                        }
                      }}
                    >
                      {editBuildingId ? 'Update Building' : 'Continue'}
                    </Button>
                    {editBuildingId ? (
                      <Button
                        onClick={() => navigate(-1)}
                        variant="cancel"
                        style={{ marginLeft: '20px' }}
                      >
                        Cancel
                      </Button>
                    ) : null}
                  </>
                ) : (
                  <SecondContainer>
                    <Typography style={{ marginBottom: '20px' }}>
                      Do you prefer to hire a professional, like an Escape Plan
                      expert, to create the drawing? If yes, we'll take care of
                      the drawing creation for you.
                    </Typography>

                    <RadioContainer>
                      <Radio
                        name="hireProfessional"
                        value="Yes"
                        onChange={() => handleHireProfessional('Yes')}
                        label="Yes"
                        checked={hasHiredProfessional}
                      />
                      <Radio
                        name="hireProfessional"
                        value="No"
                        onChange={() => handleHireProfessional('No')}
                        label="No"
                        checked={!hasHiredProfessional}
                      />
                    </RadioContainer>
                    {hasHiredProfessional ? (
                      <>
                        <Typography style={{ marginBottom: '20px' }}>
                          To create a job for building drawings, you typically
                          need to have a blueprint. However, if you don't have
                          one and need our professionals to create it for you
                          click the button below.
                        </Typography>
                        <Button
                          variant="secondary"
                          style={{ padding: '15px 20px' }}
                          onClick={() => navigate('/create-jobs/draftman')}
                        >
                          Hire Professional
                        </Button>
                      </>
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '10px',
                        }}
                      >
                        <Typography>
                          We're sorry, but without a blueprint or the option to
                          hire our professionals for drawing creation, we cannot
                          proceed further with the building creation process.
                        </Typography>
                        <Typography>
                          To continue, you have two options:
                        </Typography>

                        {optionsForCreatingBuildings.map((data, idx) => (
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '10px',
                            }}
                            key={idx}
                          >
                            <Typography strong>
                              {`${idx + 1}.`} {data.label}
                            </Typography>
                            <Typography>{data.desc}</Typography>
                          </div>
                        ))}
                      </div>
                    )}
                  </SecondContainer>
                )}
              </Form>
            );
          }}
        </Formik>
        {isOpen ? (
          <ConfirmationModalBuilding
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            message={`Are you sure want to ${editBuildingId ? 'update' : 'create'} this building?`}
            title="Building"
            okText={editBuildingId ? 'Update' : 'Create'}
            onOk={async () => {
              if (formikRef.current) {
                await formikRef.current.validateForm();
                if (Object.keys(formikRef.current.errors).length > 0) {
                  setIsOpen(false);
                }
                formikRef.current.handleSubmit();
              }
            }}
            loading={loading}
          />
        ) : (
          ''
        )}
      </BuildingContainer>
    </ViewJobContainerStyled>
  );
};

export default AddBuilding;
